export default "__VITE_ASSET__DL2Lt4TA__"